import cn from 'classnames';
import { FC } from 'react';

import { useMedia } from '@/shared/hooks';
import { Avatar, Tooltip } from '@/shared/ui';

import { OrganizationMember } from '@/entities/organization';
import { useDoctorDetails } from '@/entities/organization/hooks/useDoctorDetails';

import styles from './DoctorsAvatars.module.scss';

type DoctorsAvatarsProps = {
  doctor: OrganizationMember;
  isOnlyOneDoctor: boolean;
  className?: string;
  disabled?: boolean;
  size?: number;
  testID?: string;
};

export const DoctorsAvatars: FC<DoctorsAvatarsProps> = (props) => {
  const { doctor, isOnlyOneDoctor, className, disabled, size, testID } = props;

  const { isMobile } = useMedia();

  const { doctorFullName, doctorInitials, doctorAvatarSrc } =
    useDoctorDetails(doctor);

  return (
    <div
      className={cn(styles.container, className)}
      data-testid={testID}
      data-component="doctors-avatars"
    >
      {isMobile && (
        <Avatar
          size={32}
          src={doctorAvatarSrc}
          disabled={disabled}
          alt={doctorFullName}
          initials={doctorInitials}
          key={doctor.UserID ?? ''}
        />
      )}

      {!isMobile && isOnlyOneDoctor && (
        <>
          <Avatar
            size={size}
            src={doctorAvatarSrc}
            disabled={disabled}
            alt={doctorFullName}
            initials={doctorInitials}
            key={doctor.UserID ?? ''}
            className={styles.notHoveredAvatar}
          />

          <p className={cn('p2', styles.fullName)}>{doctorFullName}</p>
        </>
      )}

      {!isMobile && !isOnlyOneDoctor && (
        <Tooltip.Third
          content={doctorFullName}
          delayDuration={0}
          side="right"
          align="end"
          alignOffset={-9}
        >
          <Avatar
            size={size}
            src={doctorAvatarSrc}
            disabled={disabled}
            alt={doctorFullName}
            initials={doctorInitials}
            key={doctor.UserID ?? ''}
          />
        </Tooltip.Third>
      )}
    </div>
  );
};
